import React from 'react';
import ReactDOM from 'react-dom';
import './theme/base/variables.css';
import './theme/base/reset.css';
import App from './component/root/App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline, ThemeProvider, Theme, StyledEngineProvider } from '@mui/material';
import theme from './theme';
import { PostMessageProvider } from 'component/postMessage/PostMessageProvider';
import { SnackbarProvider } from 'notistack';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

ReactDOM.render(
  <React.StrictMode>
    <PostMessageProvider>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <SnackbarProvider
            maxSnack={1}
            classes={{
              variantSuccess: 'snackSuccess',
              variantInfo: 'snackInfo',
              variantError: 'snackError',
            }}
          >
            <CssBaseline />
            <App />
          </SnackbarProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </PostMessageProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
